import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const LanguageContext = createContext();

const LANGUAGES = [
  { code: "english", name: "English", nativeName: "English", flag: "🇺🇸" },
  { code: "marathi", name: "Marathi", nativeName: "मराठी", flag: "🇮🇳" },
];

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      const stored = window.localStorage.getItem("myboq-language");
      if (stored && LANGUAGES.find(l => l.code === stored)) return stored;
    } catch (e) {}
    return "english";
  });

  useEffect(() => {
    window.localStorage.setItem("myboq-language", language);
    document.documentElement.lang = language === "marathi" ? "mr" : "en";
  }, [language]);

  const changeLanguage = useCallback((langCode) => {
    if (LANGUAGES.find(l => l.code === langCode)) {
      setLanguage(langCode);
    }
  }, []);

  const currentLang = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  return (
    <LanguageContext.Provider value={{ language, currentLang, changeLanguage, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export default LanguageContext;